<template>
  <div class="cmdb-page">
    <div class="header-wrap">
      <img src="../../assets/operations/cmdb_header_bg.png" class="header-line" />
      <div class="header-img-bg">
        <header class="header">
          <div class="header-content">
            <h1>CMDB配置管理数据库</h1>
            <p>构建 IT资产全景视图实现配置项自动发现，关系映射和变更追踪<br>为IT服务管理提供准确、实时、可靠的配置数据支撑</p>
          </div>
        </header>

        <section class="architecture">
          <div class="architecture-item">
            <h3>数据采集层</h3>
            <ul>
              <li>自动发现</li>
              <li>API接入</li>
              <li>手动录入</li>
              <li>批量导入</li>
            </ul>
          </div>
          <div class="architecture-item">
            <h3>数据处理层</h3>
            <ul>
              <li>数据清洗</li>
              <li>关系构建</li>
              <li>版本控制</li>
              <li>合规检查</li>
            </ul>
          </div>
          <div class="architecture-item">
            <h3>应用服务层</h3>
            <ul>
              <li>配置查询</li>
              <li>影响分析</li>
              <li>拓扑展示</li>
              <li>报表分析</li>
            </ul>
          </div>
        </section>
      </div>
    </div>

    <section class="core-features">
      <div class="section-title">
        <h2>核心功能</h2>
        <p>持续探索先进技术与行业实践，坚持与客户长期共赢</p>
      </div>
      <section class="production card">
        <div class="item">
          <img src="../../assets/operations/cmdb1.png">
          <div>
            <p class="title">自动发现与采集</p>
            <p class="desc">支持网络扫描、Agent采集、API对接等多种方式，自动发现IT资产，实时同步配置信息，实现数据准确性。</p>
          </div>
        </div>
        <div class="item">
          <img src="../../assets/operations/cmdb2.png">
          <div>
            <p class="title">关系拓扑管理</p>
            <p class="desc">可视化展示配置项之间的依赖关系，支持多层级、多维度的拓扑视图，快速定位故障影响范围。</p>
          </div>
        </div>
        <div class="item">
          <img src="../../assets/operations/cmdb3.png">
          <div>
            <p class="title">配置基线与合规</p>
            <p class="desc">建立标准配置基线，自动检测配置偏差，及时发现不合规项，保障IT环境的标准化和安全性。</p>
          </div>
        </div>
        <div class="item">
          <img src="../../assets/operations/cmdb4.png">
          <div>
            <p class="title">变更影响分析</p>
            <p class="desc">基于配置关系进行变更影响评估，预测变更可能影响的业务和服务，降低变更风险。</p>
          </div>
        </div>
        <div class="item">
          <img src="../../assets/operations/cmdb5.png">
          <div>
            <p class="title">资产生命周期管理</p>
            <p class="desc">从采购、上线、运行到下线报废，全程跟踪资产状态，优化资产利用率，控制IT成本。</p>
          </div>
        </div>
        <div class="item">
          <img src="../../assets/operations/cmdb6.png">
          <div>
            <p class="title">权限与审计</p>
            <p class="desc">细粒度的权限控制，完整的操作审计日志，实现配置数据的安全性和可追溯性。</p>
          </div>
        </div>
      </section>
    </section>

    <section class="why-choose">
      <div class="section-title">
        <h2>为什么选择我们的CMDB?</h2>
        <p>值得信赖的业务伙伴，超百家行业领头羊的选择，为一流客户提供一流产品与服务</p>
      </div>

      <div class="why-content">
        <div class="why-list">
          <div class="why-item">
            <img src="../../assets/operations/cmdb8.png" class="why-item-img" />
            <span>自动化程度高：减少80%的手工维护工作量</span>
          </div>
          <div class="why-item">
            <img src="../../assets/operations/cmdb8.png" class="why-item-img" />
            <span>数据准确性：实时同步，准确率达99%以上</span>
          </div>
          <div class="why-item">
            <img src="../../assets/operations/cmdb8.png" class="why-item-img" />
            <span>灵活可扩展：支持自定义模型，适应各种IT环境</span>
          </div>
          <div class="why-item">
            <img src="../../assets/operations/cmdb8.png" class="why-item-img" />
            <span>开放集成：提供丰富的API，轻松对接各类运维工具</span>
          </div>
        </div>
        <img src="../../assets/operations/cmdb7.png" class="image-container" />
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'CMDBPage'
}
</script>

<style lang="scss">
.cmdb-page {
  color: #333;
  background-color: #fff;
  margin: 0;
  padding: 0;

  .header-wrap {
    background: #000;
    height: 620px;
    position: relative;
  }

  .header-line {
    width: 1400px;
    position: absolute;
    top: -140px;
    left: 50%;
    transform: translateX(-50%);
  }

  .header {
    color: #fff;
    padding-top: 80px;
    position: relative;
    overflow: hidden;
    text-align: center;
  }

  .header-content {
    position: relative;
    z-index: 2;
  }

  .header h1 {
    font-size: 38px;
    margin-bottom: 20px;
  }

  .header p {
    font-size: 16px;
    color: #ccc;
    line-height: 1.8;
    margin: 0 auto;
  }

  .architecture {
    display: flex;
    justify-content: center;
    color: #fff;
    gap: 160px;
    margin-top: 180px;
  }

  .architecture-item {
    text-align: center;
  }

  .architecture-item h3 {
    font-size: 18px;
    margin-bottom: 12px;
  }

  .architecture-item ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .architecture-item li {
    font-size: 14px;
    margin-bottom: 6px;
    color: #ccc;
  }

  .core-features {
    padding: 60px 0 20px 0;
    background-color: #F7F7F7;

    .section-title {
      text-align: center;
      margin-bottom: 20px;
    }
  }

  .features-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 40px;
    max-width: 1180px;
    margin: 0 auto;
    padding: 0 20px;
  }

  .auto-discovery-section {
    flex: 1;
    padding: 32px;
    background: #fff;

    .blue-icon {
      width: 50px;
    }

    .yellow-icon {
      width: 28px;
    }
  }

  .auto-discovery-section-title {
    font-size: 18px;
    color: #333;
  }

  .auto-discovery-section-desc {
    font-size: 14px;
    line-height: 1.6;
    color: #666;
  }

  .why-choose {
    padding: 60px 0;
    background: linear-gradient(255.98deg, rgba(41, 45, 255, 0.15) 1.86%, rgba(41, 111, 255, 0.15) 38.88%, rgba(41, 111, 255, 0.1) 51.32%, rgba(41, 111, 255, 0.15) 87.41%);

    .section-title {
      text-align: center;
      margin-bottom: 20px;
    }
  }

  .why-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 1180px;
    margin: 0 auto;
  }

  .why-list {
    width: 50%;
  }

  .why-item {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    background: #fff;
    padding: 10px 24px;
    border-radius: 30px;
  }

  .why-item-img {
    width: 30px;
    margin-right: 20px;
    margin-top: 2px;
  }

  .why-item span {
    font-size: 16px;
    color: #333;
    line-height: 1.5;
  }
   .section-title h2 {
    font-size: 24px;
    color: #333;
    margin: 0;
    margin-bottom: 15px;
  }

  .section-title p {
    font-size: 14px;
    color: #666;
    max-width: 600px;
    margin: 0 auto;
  }

  .image-container {
    width: 450px;
  }

  .area {
    padding-bottom: 30px;
    padding-top: 50px;

    @media screen and (max-width: $max-width-standard) {
      padding-bottom: 24px;
      padding-top: 40px;
    }
  }

  .card {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    max-width: 1180px;
    margin-left: auto;
    margin-right: auto;

    &.production {
      .item {
        width: 90%;

        @media (min-width: $min-width-standard) {
          &.item {
            width: 45%;
          }
        }
      }
    }

    &.advantage {
      .item {
        width: 90%;

        @media (min-width: $min-width-standard) {
          &.item {
            width: 30%;
          }
        }
      }
    }

    &.fast {
      .item {
        width: 90%;
        flex-direction: column;
        align-items: center;
        text-align: center;

        img {
          margin-right: 0;
          margin-bottom: 20px;
        }

        @media (min-width: $min-width-standard) {
          &.item {
            width: 30%;
          }
        }
      }
    }

    .item {
      display: flex;
      padding: 25px 15px;

      @media screen and (max-width: $max-width-standard) {
        padding: 15px 15px;
      }

      margin: 10px auto;

      @media (min-width: $min-width-standard) {
        &.item {
          margin: 10px 0;
        }
      }

      img {
        display: block;
        flex-shrink: 0;
        width: 60px;
        object-fit: contain;
        margin-right: 15px;
      }

      .title {
        font-size: 20px;
        line-height: 28px;
        margin-bottom: 15px;

        @media screen and (max-width: $max-width-standard) {
          font-size: 15px;
          margin-bottom: 8px;
        }
      }

      .desc {
        color: $text-grey;
        line-height: 22px;
        font-size: 14px;
        margin-bottom: 0;

        @media screen and (max-width: $max-width-standard) {
          font-size: 12px;
        }
      }
    }
  }
}
</style>
